import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'psm-timezone-editor',
    templateUrl: 'editTimezone.component.html'
})

export class EditTimezoneComponent  {

    @Input()
    public isTimezoneManual: boolean;
    @Output()
    public isTimezoneManualChange: EventEmitter<boolean> = new EventEmitter();

    @Input()
    public timezone: string;
    @Output()
    public timezoneChange: EventEmitter<string> = new EventEmitter();

    @Output()
    public change: EventEmitter<void> = new EventEmitter();
}



// WEBPACK FOOTER //
// ./src/app/views/devices/editTimezone/editTimezone.component.ts